export default __webpack_public_path__ + "static/media/aakashlogo-colored.9c3bd695.svg";